<template>
  <div>
    <div class="container">
      <div class="logo"></div>
      <div class="box">
        <form autocomplete="off" @submit.prevent="login()">
          <b-field label="Usuário ou endereço de e-mail">
            <b-input v-model="user.email" type="email" required/>
          </b-field>

          <b-field label="Senha">
            <b-input v-model="user.senha" type="password" required/>
          </b-field>

          <div class="recovery-password is-fullwidth has-text-right">
            <a href="#">Recuperar senha?</a>
          </div>

          <button class="button is-success is-fullwidth" ref="loginButton">Entrar</button>
        </form>
      </div>

      <hr>

      <button type="button" class="button is-grey is-fullwidth">Cadastre-se agora</button>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import "./src/css/views/Login";
</style>


<script>
export default {
  name: "Login",
  data: () => ({
    user: {
      email: null,
      senha: null
    }
  }),

  methods: {
    async login() {
      this.$refs.loginButton.classList.add("is-loading");

      await this.$store.dispatch("user/login", this.user);

        if(this.error) {
            this.$alert("Erro!", this.$store.state.user.error, "danger");
            this.$store.commit('user/setError', null)
            this.$refs.loginButton.classList.remove("is-loading");
        } else {
            this.$alert("Sucesso!", "Seja bem-vindo!", "success");
        }
    }
  },
  computed: {
    error() {
      return this.$store.state.user.error;
    }
  }
};
</script>